import React, { useState } from "react";
import "./countBox.css";
import ArrowUp from "../../assets/images/upArrow.svg";
import ArrowDown from "../../assets/images/downArrowBlack.svg";
import CountBoxContent from "../../constants/contentFile.json";

const CountBox = ({
  zone,
  zoneName,
  employeeList,
  count,
  visibility = false,
  leftHead = CountBoxContent?.countBox?.categoryType,
  righthead = CountBoxContent?.countBox?.totalCount,
}) => {
  const [showList, setShowList] = useState(visibility);
  const countBoxConstants = CountBoxContent?.countBox;

  const employeeCount = employeeList?.map((item, index) => {
    return (
      <div className="detailCountBox" key={index}>
        <div className="categoryCountBox">
          <span className="detailTextCountBox">{item?.name}</span>
        </div>
        <div className="countCountBox">
          <span className="detailTextCountBox">{item?.total}</span>
        </div>
      </div>
    );
  });
  return (
    <>
      <div
        className={
          showList == false ? "countBoxContainerNoList" : "countBoxContainer"
        }
      >
        <div className="zoneCountBoxInnerContainer">
          <div className="zoneNameCountBox">
            <div className="zoneContainer">
              <span className="zoneTextCountBox">{zone}</span>
            </div>
            <div className="zoneNameContainer">
              {zone === "Zone 1" && (
                <span className="zoneTextCountBox">PVC COMPOUNDING</span>
              )}
              {zone === "Zone 2" && (
                <span className="zoneTextCountBox">WIRES FACTORY</span>
              )}
            </div>
          </div>
          <div className="employeeCountBox">
            <div className="zoneCountContainer">
              <span className="countTextCountBox">{count}</span>
            </div>
            <div className="arrowContainerCountBox">
              <div
                className="arrowInnerContainerCountBox"
                onClick={() => {
                  setShowList(!showList);
                }}
              >
                {showList == true ? (
                  <img src={ArrowUp} alt="img" />
                ) : (
                  <img src={ArrowDown} alt="img" />
                )}
              </div>
            </div>
          </div>
        </div>
        {showList == true ? (
          <div className="zoneCountListContainer">
            <div className="zoneCountListInnerContainer">
              <div className="tableHeadingCountBox">
                <div className="typeCategoryCountBox">
                  <span className="countTableHeaderText">{leftHead}</span>
                </div>
                <div className="totalCountBox">
                  <span className="countTableHeaderText">{righthead}</span>
                </div>
              </div>
              <div className="listDataContainerCountBox scrolBarStyle">
                {employeeCount}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default CountBox;
